import { Directive, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appRandomAvatar]',
  standalone: true,
})
export class RandomAvatarDirective implements OnInit {
  AVATAR_SIZE = {
    SM: 'small',
    SMM: 'extra-small',
    SMMM: 'extra-small-secondary',
    MD: 'medium',
    LG: 'large',
  };

  @Input('appRandomAvatar') dataLabel: string = 'UU';
  @Input('avatarSize') avatarSize: string = this.AVATAR_SIZE.SM;

  constructor(
    private el: ElementRef,
    private renderer: Renderer2
  ) {}

  ngOnInit() {
    const charCodeRed = this.dataLabel.charCodeAt(0);
    const charCodeGreen = this.dataLabel.charCodeAt(1) || charCodeRed;

    const red = Math.pow(charCodeRed, 7) % 400;
    const green = Math.pow(charCodeGreen, 7) % 400;
    const blue = (red + green) % 400;

    let color, backgroundColor, filter, boxShadow, borderRadius;

    backgroundColor = `rgba(${red}, ${green}, ${blue}, 0.4)`;
    filter = `brightness(1.4)`;
    color = `rgb(${red}, ${green}, ${blue})`;
    boxShadow = '1px 1px 5px 0px rgb(0 0 0 / 75%)';
    borderRadius = '50%';

    // Apply generated styles to the element
    this.renderer.setStyle(this.el.nativeElement, 'color', color);
    this.renderer.setStyle(
      this.el.nativeElement,
      'background-color',
      backgroundColor
    );
    this.renderer.setStyle(this.el.nativeElement, 'filter', filter);
    this.renderer.setStyle(this.el.nativeElement, 'box-shadow', boxShadow);
    this.renderer.setStyle(
      this.el.nativeElement,
      'border-radius',
      borderRadius
    );
    this.renderer.setStyle(this.el.nativeElement, 'margin-right', '8px');

    // Set size based on avatarSize input (all avatars are square - same width/height)
    let size: string;
    switch (this.avatarSize) {
      case this.AVATAR_SIZE.SM:
        size = '24px';
        break;
      case this.AVATAR_SIZE.SMM:
        size = '28px';
        break;
      case this.AVATAR_SIZE.SMMM:
        size = '32px';
        break;
      case this.AVATAR_SIZE.MD:
        size = '64px';
        break;
      case this.AVATAR_SIZE.LG:
        size = '96px';
        break;
      default:
        size = '24px';
        break;
    }

    // Apply size to host element
    this.renderer.setStyle(this.el.nativeElement, 'height', size);
    this.renderer.setStyle(this.el.nativeElement, 'width', size);
    this.renderer.setStyle(this.el.nativeElement, 'min-width', size);
    this.renderer.setStyle(this.el.nativeElement, 'min-height', size);

    // For PrimeNG p-avatar: apply size to internal .p-avatar element
    const pAvatarElement = this.el.nativeElement.querySelector('.p-avatar');
    if (pAvatarElement) {
      this.renderer.setStyle(pAvatarElement, 'height', size);
      this.renderer.setStyle(pAvatarElement, 'width', size);
      this.renderer.setStyle(pAvatarElement, 'min-width', size);
      this.renderer.setStyle(pAvatarElement, 'min-height', size);
    }
  }
}
